import * as React from 'react'

function MailFilledSvg({
  fill = 'currentcolor',
  ...rest
}: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...rest}>
      <path
        d="M0.000741954 7.66913V18.5561C-0.000753087 18.8333 0.0396175 19.1092 0.120489 19.3744L7.10572 12.459L0.000741954 7.66913Z"
        fill={fill}
      />
      <path
        d="M11.9754 14.355C10.8785 14.35 9.79827 14.0868 8.82207 13.5866L1.40775 20.9411H1.45764C1.84433 21.137 2.27154 21.2395 2.705 21.2405H21.2258C21.6516 21.2381 22.0713 21.1391 22.4532 20.9511L22.553 20.8912L15.1686 13.5168C14.1889 14.0533 13.0924 14.3411 11.9754 14.355Z"
        fill={fill}
      />
      <path
        d="M16.895 12.4291L23.8802 19.4143C23.9604 19.1524 24.0008 18.8799 24 18.606V7.68909L16.895 12.4291Z"
        fill={fill}
      />
      <path
        d="M0.669319 5.75319L9.28111 11.5509C10.0805 12.0788 11.0174 12.3602 11.9754 12.3602C12.9334 12.3602 13.8703 12.0788 14.6697 11.5509L23.3015 5.75319C23.5064 5.6069 23.6712 5.41127 23.7805 5.18439C23.9031 4.94389 23.9616 4.67577 23.9501 4.40604C23.9586 4.18364 23.9177 3.96212 23.8303 3.75741C23.7544 3.5628 23.6389 3.38609 23.4911 3.23851C23.339 3.08423 23.1551 2.96503 22.9522 2.88925C22.7671 2.80543 22.5666 2.76124 22.3635 2.75952H1.59736C1.39087 2.76014 1.18685 2.80435 0.998622 2.88925C0.798164 2.96526 0.614946 3.08062 0.459762 3.22853C0.310758 3.37902 0.19515 3.55923 0.120479 3.75741C0.040898 3.95046 0.000204705 4.15732 0.000732291 4.36612C-0.00731212 4.62916 0.0510298 4.88998 0.170374 5.12452C0.275467 5.37612 0.448159 5.59371 0.669319 5.75319Z"
        fill={fill}
      />
    </svg>
  )
}

export const MailFilled = React.memo(MailFilledSvg)
